import axios from 'axios';

const createAxiosInstance = () => {
  // Check if we are in a browser (client-side)
  let token = null;
  if (typeof window !== 'undefined') {
    token = localStorage.getItem('authToken'); // Retrieve token from localStorage (client-side)
  }

  // Check for environment variable (client-side only)
  let authUrl = 'https://admin.shapeshiftingmastery.ca';
  if (typeof process !== 'undefined' && process.env.REACT_APP_AUTH_URL) {
    authUrl = "https://admin.shapeshiftingmastery.ca";  // Use process.env only in the client-side code
  }

  // If no auth URL is provided, log an error and return null
  if (!authUrl) {
    console.error("Auth URL is not defined in environment variables.");
    return null;
  }

  // Create and return axios instance
  const axiosInstance = axios.create({
    baseURL: authUrl, // Your Laravel API base URL
    headers: {
      Authorization: token ? `Bearer ${token}` : '', // Add token to the Authorization header
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  return axiosInstance;
};

const axiosInstance = createAxiosInstance();

export default axiosInstance;
